import { render, staticRenderFns } from "./CardLoginRegister.vue?vue&type=template&id=2a902f45&"
import script from "./CardLoginRegister.vue?vue&type=script&lang=js&"
export * from "./CardLoginRegister.vue?vue&type=script&lang=js&"
import style0 from "./CardLoginRegister.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports